import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import styles from './styles';
import { colors } from '~/themes/variables';
const DivWrap = styled.div `
  ${styles}
`;
const CircleIcon = ({ borderColor, icon, iconBG = colors.violetContainer, size = 76 }) => {
    return (_jsx(DivWrap, { borderColor: borderColor, iconBG: iconBG, size: size, children: _jsx("img", { src: icon }) }));
};
export default CircleIcon;
